import React, { useEffect, useState } from "react";

/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { calculateRoundShopTime } from "../../../shared/utils";
import { ShopConstants, SimulationConstants } from "../../../shared/constants";
import { GameClient } from "../gameClient";
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";

interface TitleProps {
	currentState: string,
	round: number,
};

const width = 15;

const style = css`
	text-align: center;
	position: absolute;
	right: 0;
	background: grey;
    text-align: center;
    border-bottom-left-radius: 1vw;
	border-left: 1px solid ${Colors.UITextAndBorders};
	border-right: 1px solid ${Colors.UITextAndBorders};
	border-bottom: 1px solid ${Colors.UITextAndBorders};
`;

const heading = css`
	font-family: 'NotoSansDisplay', sans-serif;
	font-size: 2.5rem;
	text-transform: Capitalize;
	margin-block-start: 0;
	margin-block-end: 0;
    width: ${width}vw;
    text-align: center;
	background: url(${backgroundTexture});
	background-color: ${Colors.UIBackground};
`;

const container = css`
	display: grid;
	grid-template-areas: inner-div;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr;
    width: ${width}vw;
	height: fit-content;
    border-bottom-left-radius: 1vw;
`;

const backgroundBar = css`
	grid-area: inner-div;
	background: grey;
    width: ${width}vw;
	height: 100%;
    border-bottom-left-radius: 1vw;
`;

const progressBar = css`
	grid-area: inner-div;
	background: ${Colors.UITimer};
	height: 100%;
	justify-self: end;
    border-bottom-left-radius: 1vw;
`;

const label = css`
	grid-area: inner-div;
	color: ${Colors.UITextAndBorders};
	display: flex;
	align-self: center;
	justify-self: center;
	color: white;
`;

const TitleMap = new Map<string, string>([
	['lobby', 'Lobby'],
	['shop', 'Shop'],
	['simulation', 'Infection'],
	['recap', 'Recap'],
]);

export const Title = ({ currentState, round }: TitleProps) => {
	// Temp skip round/simulation
	const [hovered, setHovered] = React.useState(false);
	const hover = () => {
		setHovered(!hovered);
	}

	const maxRounds = SimulationConstants.MaxRoundsByTrainingLevel[gameClient.trainingLevel];

	return (
		<div css={style}>
			<h1 css={heading} onMouseEnter={hover} onMouseLeave={hover}>{TitleMap.get(currentState)}</h1>
			{currentState !== 'lobby' &&
				<ProgressBar label={gameClient.endlessMode ? `Endless Round ${round}` : `Round ${round} / ${maxRounds}`} />
			}
		</div>
	)
};

declare var gameClient: GameClient;

type ProgressBarProps = {
	label: string;
};


const ProgressBar: React.FC<ProgressBarProps> = (props: ProgressBarProps) => {
	const [timeleft, setTimeleft] = useState(100);
	const refTimeleft = React.useRef(timeleft);

	let elapsed = 0;

	useEffect(() => {
		const interval = setInterval(() => {
			elapsed += 1;
			if (elapsed * 1000 > ShopConstants.RecapStateTotalMS) {
				const shopElapsed = elapsed - ShopConstants.RecapStateTotalMS / 1000;
				const total = (calculateRoundShopTime(gameClient) - ShopConstants.RecapStateTotalMS) / 1000;
				const remaining = total - shopElapsed;
				refTimeleft.current = (remaining - 1) / 10;
				refTimeleft.current = remaining / total;
				setTimeleft(refTimeleft.current);
			} else {
				refTimeleft.current = 1;
				setTimeleft(refTimeleft.current);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [props.label]);


	return (
		<div css={container}>
			<div css={backgroundBar}></div>
			<div css={progressBar} style={{ width: `${Math.min(width * refTimeleft.current, width)}vw` }}></div>
			<div css={label}>{props.label}</div>
		</div>
	)
};